<template>
  <el-dialog
    title="设置视频弹题"
    width="70%"
    :visible.sync="visible"
    :before-close="handleClose"
    destroy-on-close
  >
    <div>知识点: {{ knowledgeName }}</div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="弹题时间">
        <el-time-picker
          v-model="form.time"
          :picker-options="{
            selectableRange: maxTime,
          }"
          value-format="HH:mm:ss"
          format="HH:mm:ss"
          placeholder="请选择弹题时间"
        >
        </el-time-picker>
        <span style="margin-left: 10px">当前视频总时长为：{{ totalTime }}</span>
        <div style="font-size: 12px; color: #ccc">
          视频弹题时间，格式为00:10:10，不能大于视频总时长，课件为视频时可用，设置为0则为随机时长弹题
        </div>
      </el-form-item>
      <el-form-item label-width="0">
        <!--        <el-select v-model="form.choose1" placeholder="请选择" style="width: 30%;">-->
        <!--          <el-option-->
        <!--            v-for="item in options1"-->
        <!--            :key="item"-->
        <!--            :label="item"-->
        <!--            :value="item" >-->
        <!--          </el-option>-->
        <!--        </el-select>-->
        <!--        <el-select v-model="form.choose2" placeholder="请选择" style="width: 68%;margin-left: 10px;">-->
        <!--          <el-option-->
        <!--            v-for="item in options2"-->
        <!--            :key="item"-->
        <!--            :label="item"-->
        <!--            :value="item" >-->
        <!--          </el-option>-->
        <!--        </el-select>-->
        <el-input
          v-model="form.search"
          placeholder="请输入内容"
          style="width: 50%; margin-right: 10px; margin-top: 10px"
        ></el-input>
        <el-button type="primary" style="margin-top: 10px" @click="search"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item label-width="0">
        <template>
          <el-table
            ref="multipleTable"
            :data="form.tableData"
            style="width: 100%"
            row-key="examsQuestionId"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
            ></el-table-column>
            <el-table-column prop="examsQuestionId" label="试题ID">
            </el-table-column>
            <el-table-column prop="content" label="试题内容">
              <template #default="scope">
                <span class="operation" style="color: #606266">{{
                  htmlDecode(scope.row.content)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="knowledgeName" label="知识点">
            </el-table-column>
            <el-table-column prop="questionTypeTitle" label="试题类型">
            </el-table-column>
            <el-table-column prop="level" label="难度">
              <!--              <template #default="scope">-->
              <!--                <span class="operation" style="color: #606266;" v-if="scope.row.level == '1'" >简单</span>-->
              <!--                <span class="operation" style="color: #606266;" v-if="scope.row.level == '2'" >中等</span>-->
              <!--                <span class="operation" style="color: #606266;" v-if="scope.row.level == '3'" >困难</span>-->
              <!--              </template>-->
            </el-table-column>
          </el-table>
        </template>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      style="width: 100%; display: inline-block; text-align: center"
    >
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button type="" @click="cancel">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { http } from '@/utils/axios'
import * as api from '@/api/courseStructure/courseStructure'
export default {
  props: [],
  name: 'CourseVideoPlayer',
  data() {
    return {
      knowledgeName: '',
      knowledgeId: '',
      maxTime: '',
      totalTime: '',
      visible: false,
      form: {
        time: '',
        choose1: '',
        choose2: '',
        search: '',
        tableData: [],
      },
      options1: ['1', '2', '3'],
      options2: ['1', '2', '3'],
      courseWareId: '',
      id: '',
      qid: '',
    }
  },
  methods: {
    getKnowledgeName() {
      api.getKnowledgeName({ id: this.id }).then(({ data }) => {
        if (data.code === 100000) {
          this.knowledgeName = data.data.knowledgeName
          this.knowledgeId = data.data.id
          this.form.time = data.data.popupProblemTime || '00:00:00'
          this.getList()
        }
      })
    },
    getList() {
      api
        .getQuestionList({
          courseWareId: this.courseWareId,
          content: this.form.search,
          knowledgeId: this.knowledgeId,
        })
        .then(({ data }) => {
          if (data.code == 100000) {
            data = data.data
            this.form.tableData = data
            // 回显是否选中
            if (this.qid != '' || this.qid != null || this.qid != undefined) {
              const qidArr = this.qid.split(',')
              for (let i = 0; i < this.form.tableData.length; i++) {
                let index = qidArr.findIndex(
                  (item) => item == this.form.tableData[i].examsQuestionId
                )
                if (index > -1) {
                  this.$refs.multipleTable.toggleRowSelection(
                    this.form.tableData[i],
                    true
                  )
                  this.form.tableData[i].isChecked = true
                }
              }
            }
            //将勾选的排到前面
            for (let j = 0; j < this.form.tableData.length; j++) {
              for (let k = j + 1; k < this.form.tableData.length; k++) {
                if (this.form.tableData[k].isChecked) {
                  const checkedObj = this.form.tableData[k]
                  this.form.tableData[k] = this.form.tableData[j]
                  this.form.tableData[j] = checkedObj
                }
              }
            }
          } else {
            this.$message({ type: 'success', message: data.msg })
          }
        })
    },

    search() {
      this.getList()
    },

    htmlDecode(text) {
      let tmp = document.createElement('div')
      tmp.innerHTML = text
      const output = tmp.innerText || tmp.textContent
      tmp = null
      return output
    },

    // 初始化
    init(courseWareId, duration, id, qid) {
      this.visible = true
      this.id = id
      this.courseWareId = courseWareId
      this.qid = qid
      this.totalTime = this.secondsFormat(duration)
      this.maxTime = '00:00:00 - ' + this.totalTime
      this.getKnowledgeName()
    },

    // 秒转时分秒
    secondsFormat(value) {
      // var secondTime = parseInt(value); // 秒
      // var minuteTime = 0; // 分
      // var hourTime = 0; // 小时
      // if (secondTime > 60) {
      //   minuteTime = parseInt(secondTime / 60);
      //   secondTime = parseInt(secondTime % 60);
      //   if (minuteTime > 60) {
      //     hourTime = parseInt(minuteTime / 60);
      //     minuteTime = parseInt(minuteTime % 60);
      //   }
      // }
      // var result ="" +(parseInt(secondTime) < 10? "0" + parseInt(secondTime): parseInt(secondTime));
      //
      // // if (minuteTime > 0) {
      // result ="" + (parseInt(minuteTime) < 10? "0" + parseInt(minuteTime) : parseInt(minuteTime)) + ":" + result;
      // // }
      // // if (hourTime > 0) {
      // result ="" + (parseInt(hourTime) < 10 ? "0" + parseInt(hourTime): parseInt(hourTime)) +":" + result;
      // // }
      // return result;

      let h =
        Math.floor(value / 3600) < 10
          ? '0' + Math.floor(value / 3600)
          : Math.floor(value / 3600)
      let m =
        Math.floor((value / 60) % 60) < 10
          ? '0' + Math.floor((value / 60) % 60)
          : Math.floor((value / 60) % 60)
      let s =
        Math.floor(value % 60) < 10
          ? '0' + Math.floor(value % 60)
          : Math.floor(value % 60)
      return (value = h + ':' + m + ':' + s)
    },
    // 时分秒转秒
    toS(time) {
      let times = time.split(':')
      let second = times.length > 0 ? parseInt(times.pop()) : 0
      if (second >= 60) throw Error('格式不正确')
      let minute = times.length > 0 ? parseInt(times.pop()) : 0
      if (minute >= 60) throw Error('格式不正确')
      let hour = times.length > 0 ? parseInt(times.pop()) : 0
      if (hour >= 24) throw Error('格式不正确')

      let secondCount = hour * 3600
      secondCount += minute * 60
      secondCount += second
      return secondCount
    },

    // 处理弹窗关闭事件
    handleClose(msg) {
      this.visible = false
      this.$refs.multipleTable.clearSelection() //每次关闭页面清空全部勾选
      this.$emit('closeCourseVideoPlayer')
    },

    // 提交
    submitForm() {
      let ids = ''
      const selectedList = this.$refs.multipleTable.selection
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else {
        for (let i of selectedList) {
          ids += i.examsQuestionId + ','
        }
        api
          .addCourseStructure({
            zyVideoSectionId: this.id,
            popupProblemTime: this.form.time,
            qid: ids,
          })
          .then(({ data }) => {
            if (data.code == 100000) {
              this.$message({ type: 'success', message: data.msg })
              this.visible = false
              this.$refs.multipleTable.clearSelection()
              this.$emit('closeCourseVideoPlayer')
            } else {
              this.$message({ type: 'error', message: data.msg })
            }
          })
      }
    },
    cancel() {
      this.visible = false
      this.$refs.multipleTable.clearSelection()
      this.$emit('closeCourseVideoPlayer')
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>
.el-dialog {
  max-height: 80%;
  overflow-y: auto;
}
.chooseCourse {
  margin-right: 10px;
  font-size: 12px;
  line-height: 30px;
}
.courseChoose .courses {
  display: block;
  padding-left: 5%;
  padding-top: 10px;
}
.courseChoose {
  width: 25%;
  float: left;
  border-right: 1px dashed #ccc;
  margin-top: 20px;
  padding-bottom: 10px;
}
.courseChoose:last-child {
  border-right: none;
}
.el-checkbox__label {
  white-space: normal;
  padding-left: 5px;
}
</style>
